import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Buildings, Info } from '@phosphor-icons/react';

const ProviderConfigCard = ({ billingProvider }) => {
  const isConfigured = billingProvider?.configured;
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <Buildings size={20} className="text-indigo-600" />
            Billing Provider Configuration
          </CardTitle>
          <Badge
            variant="outline"
            className={
              isConfigured
                ? 'bg-emerald-50 text-emerald-700'
                : 'bg-amber-50 text-amber-700'
            }
          >
            {isConfigured ? 'Configured' : 'Not Configured'}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm text-slate-500">Provider Name</p>
            <p className="font-medium">{billingProvider?.name || 'Not set'}</p>
          </div>
          <div>
            <p className="text-sm text-slate-500">NPI</p>
            <p className="font-mono">{billingProvider?.npi || 'Not set'}</p>
          </div>
          <div>
            <p className="text-sm text-slate-500">Tax ID</p>
            <p className="font-mono">{billingProvider?.tax_id || 'Not set'}</p>
          </div>
        </div>
        {!isConfigured && (
          <p className="mt-4 text-sm text-amber-600 flex items-center gap-1">
            <Info size={14} />
            Set ODM_BILLING_NPI, ODM_BILLING_TAX_ID, and ODM_BILLING_NAME environment
            variables for production
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default ProviderConfigCard;
